import React, { useEffect, useRef, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { commonService } from "../../utils/commonService";
import { apiCall } from "../../utils/axiosService";
import { API_URL } from "../../utils/apiRoutes";
import { apiResponse } from "../../utils/apiResponse";
import { Button, Container, Form, Table } from "react-bootstrap";
import { errorToastMessage } from "../../utils/toastMessage";
import DatePicker from "react-datepicker";
import Loader from "../Loader/Loader";
import moment from "moment";
import NoteIcon from "../../Assets/Images/CRM/notes.svg";
import darkNoteIcon from "../../Assets/Images/CRM/darkNotes.svg";
import WidgetNote from "./WidgetNote";
import Comments from "./ListingComponent/Comments/Comment";
import infoIcon from "../../Assets/Images/Action Icons/infoIcon..svg";
import Non_WidgetDetailModal from "./NonWidgetDetailModal";
import highPriority from "../../Assets/Images/Revenue-management/highPriority.svg";
import lowPriority from "../../Assets/Images/Revenue-management/lowPriority.svg";
import { ratemetricsRoomtypes } from "../../utils/constant";
import { MultiSelect } from "primereact/multiselect";

const RMPerityCheck = ({ api, para, setting }) => {
    const [widgetModal, setWidgetModal] = useState(false);

    const closeWidgetModal = () => {
        setWidgetModal(false);
    };
    const [loading, setLoading] = useState(false);
    const [perityCheckData, setPerityCheckData] = useState(null);
    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail
    );

    const propertyCode = para?.propertyCode || para?.PropertyCode || para?.propertycode || propertyDetailFromRTK?.propertycode || "";
    const propertyId = para?.propertyId || para?.PropertyId || para?.propertyid || propertyDetailFromRTK?.propertyid || 0;

    const channelRef = useRef([]);
    const startDateDefault = new Date();
    const endDateDefault = new Date();
    endDateDefault.setDate(endDateDefault.getDate() + 14);
    // const endDateDefault = new Date(
    //   startDateDefault.getFullYear(),
    //   startDateDefault.getMonth() + 1,
    //   0
    // );
    const [startDate, setStartDate] = useState(startDateDefault);
    const [endDate, setEndDate] = useState(endDateDefault);
    const [showNoteSidebar, setShowNoteSidebar] = useState(false);
    const clickedDateForNote = useRef();
    const [tblids, settblids] = useState({
        tblPerityCheck: commonService.GenerateGUID(),
    });
    const [noteDetail, setNoteDetail] = useState(null);
    const commentAsOfDateRef = useRef();

    const [roomType, setRoomType] = useState("");
    const multiselectRef = useRef(null);
    const [selectedMarketSegment, setSelectedMarketSegment] = useState(null);
    const [selectedTempMarketSegment, setSelectedTempMarketSegment] = useState([]);

    const availableChannels = useMemo(() => {
        if (!perityCheckData?.length) return [];
        return Object.keys(perityCheckData[0])
            .filter(
                (key) =>
                    key !== "AsOfDate" &&
                    key !== "Dates" &&
                    key !== "Brand" &&
                    key?.toLowerCase() !== "unknown"
            )
            .map((key) => ({ label: key.toUpperCase(), value: key }));
    }, [perityCheckData]);

    useEffect(() => {
        if (api === 0) return;
        if (!availableChannels.length) {
            setSelectedTempMarketSegment([]);
            setSelectedMarketSegment(null);
            return;
        }

        const availableValues = availableChannels.map((item) => item.value);

        setSelectedTempMarketSegment((prev) => {
            const valid = prev.filter((value) => availableValues.includes(value));
            return valid.length === prev.length && prev.length > 0
                ? prev
                : availableValues;
        });

        setSelectedMarketSegment((prev) => {
            if (prev === null) {
                return null;
            }
            const valid = prev.filter((value) => availableValues.includes(value));
            return valid;
        });
    }, [availableChannels]);

    const handleDateChange = (dates) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
    };

    const closeNoteSideBar = () => {
        setShowNoteSidebar(false);
    };

    const getPerityCheckData = async () => {
        if (api === 0) return;
        setLoading(true);
        let asOfDateResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.AS_OF_DATE.AS_OF_DATE,
                body: { propertyCode: propertyCode },
            },
            false
        );

        if (asOfDateResponse?.status_code === 0) {
            setLoading(false);
            return errorToastMessage(asOfDateResponse?.message);
        } else if (asOfDateResponse?.status_code === 1) {
            commentAsOfDateRef.current = asOfDateResponse?.data?.[0]
                ?.last_data_refresh
                ? asOfDateResponse?.data?.[0]?.last_data_refresh
                : "";
            let perityCheckResponse = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.SnapShot + API_URL.RATESHOP.GET_PERITY_CHECK,
                    body: {
                        AsOfDate: asOfDateResponse?.data?.[0]?.last_data_refresh
                            ? asOfDateResponse?.data?.[0]?.last_data_refresh
                            : "",
                        startDate: commonService.getDateForNode(startDate),
                        endDate: commonService.getDateForNode(endDate),
                        propertyCode: propertyCode,
                        roomtype: roomType ? roomType : null
                    },
                },
                false
            );

            let response = apiResponse(false, perityCheckResponse);

            if (response?.isValidate) {
                let dataFromApi = response?.data?.data;
                setPerityCheckData(dataFromApi);
                setLoading(false);
            }

            if (!response?.isValidate) {
                setPerityCheckData(null);
                setLoading(false);
            }
        }
    };

    const getNoteByDataList = async () => {
        if (api === 0) return;
        let noteByDataListResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.Configuration +
                    API_URL.WIDGET_NOTE.GET_BY_DATA_LIST,
                body: {
                    propertyid: propertyId,
                    widgetid: para?.widgetId,
                    // widgetid: 0,
                    startdate: commonService.getDateInDBFormat(startDate),
                    enddate: commonService.getDateInDBFormat(endDate),
                },
            },
            false
        );

        let response = apiResponse(false, noteByDataListResponse);

        if (response?.isValidate) {
            setNoteDetail(response?.data?.data);
        }

        if (!response?.isValidate) {
            setNoteDetail(null);
        }
    };

    useEffect(() => {
        if (api === 0) return;
        setRoomType("");
    }, [propertyDetailFromRTK]);

    useEffect(() => {
        if (api === 0) return;
        if (startDate && endDate) {
            getPerityCheckData();
            getNoteByDataList();
        }
    }, [startDate, endDate, propertyDetailFromRTK, roomType]);

    const handleApply = () => {
        setSelectedMarketSegment([...selectedTempMarketSegment]);
        multiselectRef.current?.hide();
    };

    const footerTemplate = () => (
        <div style={{ padding: "0.5rem", textAlign: "right" }}>
            <Button id={commonService.generateGlobalClickTrackerID("RMPerityCheck", "apply", "")}
                onClick={handleApply}
            >Apply</Button>
        </div>
    );

    const availableChannelKeys = availableChannels.map((item) => item.value);
    const effectiveChannelKeys =
        selectedMarketSegment !== null
            ? selectedMarketSegment.filter((key) => availableChannelKeys.includes(key))
            : availableChannelKeys;
    const hasBrandColumn = useMemo(
        () => perityCheckData?.some((item) => item?.Brand !== undefined) ?? false,
        [perityCheckData]
    );
    const tableChannelKeys = hasBrandColumn
        ? ["Brand", ...effectiveChannelKeys]
        : effectiveChannelKeys;

    return (
        <div className="RMRateShopMain">
            <div id={commonService.generateGlobalClickTrackerID("RMPerityCheck", "div-onclick", "")}
                className="cursorPointer heading-menu-btns btn-email-all btn btn-primary"
                style={{ position: "absolute", right: "70px", top: "5px", width: "auto" }}
                onClick={() => {
                    if (api === 0) return;
                    setWidgetModal(true);
                }}
                import={tblids.tblPerityCheck}
            >
                <img src={infoIcon} alt="graphIcon" />
            </div>
            {propertyCode ? (
                <Container fluid>
                    <div className="form-groups from-groups no-border-break meghaDatePicker d-flex gap-2">
                        <div className={"width225"}>
                            <DatePicker id={commonService.generateGlobalClickTrackerID("RMPerityCheck", "datepicker-onchange", "")}
                                portalId="datepicker-root"
                                onChange={handleDateChange}
                                startDate={startDate}
                                minDate={new Date()}
                                maxDate={new Date().setDate(new Date().getDate() + 90)}
                                endDate={endDate}
                                selectsRange
                                monthsShown={2}
                            />
                        </div>
                        <div className="no-border-break width225">
                            <Form.Select id={commonService.generateGlobalClickTrackerID("RMPerityCheck", "form-select-onchange", "")} aria-label="Select Room Type" value={roomType}
                                onChange={(e) => {
                                    setRoomType(e.target.value);
                                    setSelectedTempMarketSegment([]);
                                    setSelectedMarketSegment(null);
                                }}
                            >
                                <option value="">Any Room</option>
                                {ratemetricsRoomtypes?.map((item, idx) => (
                                    <option key={idx} value={item.value}>
                                        {item.label}
                                    </option>
                                ))}
                            </Form.Select>
                        </div>
                        <MultiSelect id={commonService.generateGlobalClickTrackerID("RMPerityCheck", "multiselect-onchange", "")}
                            className={"width225"}
                            ref={multiselectRef}
                            filter
                            placeholder="Select Channels"
                            display="values"
                            selectedItemsLabel="{0} channels selected"
                            maxSelectedLabels={0}
                            closeOnSelect={false}
                            value={selectedTempMarketSegment}
                            options={availableChannels}
                            onChange={(e) => {
                                setSelectedTempMarketSegment(e.value);
                            }}
                            panelFooterTemplate={footerTemplate}
                        />
                    </div>
                    <div className="ViewPropertySetupTable mt-2">
                        <div className="stripped__table">
                            <div className="table-responsive tblDynamicPickupSticky">
                                <Table id={tblids.tblPerityCheck}>
                                    <thead className="tbl-header-sticky">
                                        <tr>
                                            <th className="width150">Date</th>
                                            {perityCheckData &&
                                                tableChannelKeys.map((key) => (
                                                    <th key={key} className="text-center">
                                                        {key}
                                                    </th>
                                                ))}
                                            <th className="width50">Notes</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr style={{ height: "80px", position: "relative" }}>
                                                <Loader />
                                            </tr>
                                        ) : perityCheckData ? (
                                            perityCheckData?.map((item) => {
                                                let checkNoteExists = noteDetail?.notedata?.filter(
                                                    (x) =>
                                                        moment(x?.datadate).format("YYYY-MM-DD") ===
                                                        moment(item?.Dates).format("YYYY-MM-DD")
                                                );
                                                return (
                                                    <tr className="shadowOnHover">
                                                        <td className="border_right">
                                                            {commonService.getDateInFormat(item?.Dates)}{" "}
                                                            {moment(new Date(item?.Dates), "l").format("ddd")}
                                                        </td>
                                                        {tableChannelKeys.map((key) => {
                                                            const rawValue = item?.[key];
                                                            const value = rawValue ? Math.round(Number(rawValue)) : 0;
                                                            const Brand = item?.Brand ? Math.round(Number(item?.Brand)) : 0;
                                                            return value > 0 ? (
                                                                <td
                                                                    key={key}
                                                                    className={`text-center ${Brand !== value
                                                                        ? "redText"
                                                                        : value !== 0 && key !== "Brand"
                                                                            ? "greenText"
                                                                            : ""
                                                                        }`}
                                                                >
                                                                    {commonService.formateAmount(value)} {" "}
                                                                    {key !== "Brand" ? (
                                                                        value - Brand !== 0 ? (
                                                                            <>
                                                                                ({value - Brand}
                                                                                <img
                                                                                    style={{ width: "10px" }}
                                                                                    src={
                                                                                        value - Brand > 0
                                                                                            ? highPriority
                                                                                            : lowPriority
                                                                                    }
                                                                                    alt="img"
                                                                                />)
                                                                            </>
                                                                        ) : (
                                                                            ""
                                                                        )
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                </td>
                                                            ) : (
                                                                <td key={key} className={"text-center"}>
                                                                    -
                                                                </td>
                                                            );
                                                        })}
                                                        <td className="border-right">
                                                            {checkNoteExists?.length > 0 ? (
                                                                <img id={commonService.generateGlobalClickTrackerID("RMPerityCheck", "note", item)}
                                                                    className="cursorPointer"
                                                                    src={darkNoteIcon}
                                                                    onClick={() => {
                                                                        clickedDateForNote.current = item?.Dates;
                                                                        setShowNoteSidebar(true);
                                                                    }}
                                                                    alt="note"
                                                                />
                                                            ) : (
                                                                <img id={commonService.generateGlobalClickTrackerID("RMPerityCheck", "note", item)}
                                                                    className="cursorPointer"
                                                                    src={NoteIcon}
                                                                    onClick={() => {
                                                                        clickedDateForNote.current = item?.Dates;
                                                                        setShowNoteSidebar(true);
                                                                    }}
                                                                    alt="note"
                                                                />
                                                            )}
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td>No Data Found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div>
                    {
                        api !== 0 &&
                        <Comments
                            widgetDetails={para}
                            // widgetDetails={{
                            //     asOfDate: commentAsOfDateRef.current,
                            //     propertyDetail: {
                            //         propertyid: propertyId
                            //             ? propertyId
                            //             : "",
                            //         propertyname: propertyDetailFromRTK?.propertyname
                            //             ? propertyDetailFromRTK?.propertyname
                            //             : "",
                            //     },
                            //     // widgetId: 999994,
                            //     widgetid: para?.widgetId,
                            //     rowTitle: "Parity Check",
                            //     associationtype: "Parity Check",
                            //     widgetname: "Parity Check",
                            //     snapshottitle: "Parity Check",
                            // }}
                            editorId={"RMPerityCheck"}
                        />
                    }
                </Container>
            ) : (
                <Container>
                    <div className="d-flex justify-content-center">
                        <h5>Please Select Property</h5>
                    </div>
                </Container>
            )
            }
            {
                showNoteSidebar && (
                    <WidgetNote
                        show={showNoteSidebar}
                        handleClose={closeNoteSideBar}
                        // widgetId={117}
                        widgetId={para?.widgetId}
                        propertyId={propertyId}
                        rowTitle={"Perity Check"}
                        dateForNote={clickedDateForNote.current}
                    />
                )
            }
            {
                widgetModal && (
                    <Non_WidgetDetailModal
                        showModal={widgetModal}
                        closeModal={closeWidgetModal}
                        non_widgetname={"Parity Check"}
                    />
                )
            }
        </div >
    );
};

export default RMPerityCheck;
